<div class="login-page relative !flex !min-h-screen !flex-col !overflow-hidden !bg-gradient-to-br !from-primary !to-secondary lg:!flex-row">
    <div
        class="login-bg-pattern pointer-events-none !absolute !inset-0 !bg-cover !bg-center !opacity-20 mix-blend-overlay"
        aria-hidden="true"
    ></div>
    <div class="login-bg-glow pointer-events-none !absolute !inset-0" aria-hidden="true"></div>

    <!-- Branding panel -->
    <section
        class="login-brand-panel relative !z-10 !flex !w-full !min-h-[280px] !flex-col !justify-between !px-6 !py-10 !text-center !text-white lg:!min-h-screen lg:!w-1/2 lg:!items-start lg:!px-16 lg:!py-12 lg:!text-left"
    >
        <div class="!flex !w-full !max-w-lg !flex-col !items-center !gap-8 lg:!items-start">
            <a [routerLink]="['/login']" class="login-logo-link !inline-flex !transition-opacity hover:!opacity-90">
                <span
                    class="login-logo-wrap"
                    [class.login-logo-wrap--company]="isCompanyBranded"
                >
                    <img
                        [src]="brandingLogo"
                        [alt]="isCompanyBranded ? company!.name + ' logo' : 'Well Done logo'"
                        class="login-logo"
                        [class.brand-logo--default]="!isCompanyBranded"
                        [class.brand-logo--company]="isCompanyBranded"
                    />
                </span>
            </a>

            <div class="login-welcome !space-y-4" *ngIf="!loadingCompany">
                <p class="!mb-0 !text-xs !font-semibold !uppercase !tracking-[0.22em] !text-white/75">
                    Area riservata
                </p>
                <h1 class="login-title !mb-0 !text-3xl !font-bold !leading-tight !text-white sm:!text-4xl lg:!text-5xl">
                    {{ welcomeTitle }}
                </h1>
                <p class="login-subtitle !mb-0 !max-w-md !text-base !leading-relaxed !text-white/90 sm:!text-lg">
                    {{ welcomeSubtitle }}
                </p>
            </div>

            <div *ngIf="loadingCompany" class="!h-28 !w-full !max-w-sm !animate-pulse !rounded-2xl !bg-white/20"></div>
        </div>

        <p
            *ngIf="isCompanyBranded"
            class="login-powered-by !mb-0 !mt-8 !flex !items-center !justify-center !gap-2 !text-sm !text-white/65 lg:!mt-0 lg:!justify-start"
        >
            <span>Powered by</span>
            <img src="assets/logo.svg" alt="Well Done" class="brand-logo--default !h-5 !w-auto !opacity-90" />
        </p>
    </section>

    <!-- Form panel -->
    <section class="login-form-panel relative !z-10 !flex !w-full !items-center !justify-center !px-4 !py-10 sm:!px-6 lg:!w-1/2 lg:!px-10 lg:!py-12">
        <div class="login-card !w-full !max-w-lg !rounded-[1.75rem] !border !border-white/60 !bg-white !p-7 !shadow-2xl !shadow-black/15 sm:!p-9">
            <div class="login-card-header !mb-8 !text-center lg:!text-left">
                <h2 class="login-card-title !mb-0 !text-2xl !font-bold !text-strong sm:!text-3xl">Recupera password</h2>
                <p class="!mb-0 !mt-2 !text-sm !leading-relaxed !text-subtle sm:!text-base">
                    Inserisci la tua email per ricevere le istruzioni di recupero
                </p>
            </div>

            <form #forgotPassword="ngForm" class="login-form !space-y-6">
                <div>
                    <label for="email" class="login-label !mb-2 !block !text-sm !font-semibold !text-muted">
                        Email
                    </label>
                    <input
                        #emailInput
                        required
                        name="email"
                        type="email"
                        class="login-input"
                        id="email"
                        aria-describedby="email"
                        placeholder="nome@esempio.it"
                        [(ngModel)]="email"
                    />
                </div>

                <div class="!flex !flex-col !gap-4 !pt-1">
                    <button
                        type="submit"
                        class="login-submit-btn"
                        (click)="recoverPassword()"
                        [disabled]="forgotPassword.invalid"
                    >
                        Invia istruzioni
                    </button>

                    <p class="!mb-0 !text-center !text-sm !text-subtle">
                        Ricordi la password?
                        <a [routerLink]="['/login']" class="login-link !font-semibold !text-primary !no-underline">
                            Torna al login
                        </a>
                    </p>
                </div>
            </form>
        </div>
    </section>
</div>
